define([
    'underscore',
    'edge/platform/util/StringUtil',
    './_VMListNode',
    './_VMNode',
    './_AncestorChainFactory',
    './build/_Step'], (_, StringUtil, _VMListNode, _VMNode, _AncestorChainFactory, _Step)=> {
    /**
     * Return a factory to create new view model objects using registered aspects
     *
     * @param aspects {Array}: Aspect factory objects that have been registered with the ViewModel API
     *
     * @return {Object}: A factory object with a create function for creating new view model objects
     **/
    return (aspects)=> {
        function createRootViewModelNode(modelRoot, metadataInfo) {
            const VMNode = _VMNode(modelRoot, aspects);
            const VMListNode = _VMListNode(VMNode, createViewModelNode);

            const viewModelNode = new VMNode(metadataInfo, _AncestorChainFactory.emptyChain);

            /* Set view model nodes for properties of a DTO view model node */
            function setDTOProperties(_viewModelNode) {
                function setDTOProperty(dtoViewModel, propertyName, propertyMetadataInfo, propertyAncestorChain) {
                    const getOrCreateViewModelNode = _.once(
                        ()=> {
                            return createViewModelNode(dtoViewModel, propertyName, _Step.property(propertyMetadataInfo.dtoType.xCenter.name, propertyMetadataInfo), propertyAncestorChain);
                        });

                    Object.defineProperty(dtoViewModel, propertyName, {
                        get: ()=> {
                            if (!dtoViewModel.value) {
                                return;
                            }
                            //create node lazily if parent node has a value
                            return getOrCreateViewModelNode();
                        },
                        set: (vmNodeOrModel)=> {
                            getOrCreateViewModelNode().set(vmNodeOrModel);
                        },
                        enumerable: true
                    });
                }

                const pathBuilder = _AncestorChainFactory.build(_viewModelNode, _viewModelNode._metadataInfo, _viewModelNode._ancestorChain);
                const metadataProperties = _viewModelNode._metadataInfo.valueType.typeInfo.properties;
                metadataProperties.forEach((properyMetadata)=> {
                    const propertyName = StringUtil.lowercaseFirstLetter(properyMetadata.name);
                    const propertyAncestorChain = pathBuilder.forChild(properyMetadata.name);
                    setDTOProperty(_viewModelNode, propertyName, properyMetadata, propertyAncestorChain);
                });
            }

            /* Create a view model node for the current metadata and ancestor chain. */
            function createViewModelNode(_parentViewModel, accessorCode, _metadataInfo, ancestorChain) {
                if (_metadataInfo.valueType.isCollection) {
                    return new VMListNode(_metadataInfo, ancestorChain, accessorCode);
                }
                const _viewModelNode = new VMNode(_metadataInfo, ancestorChain, accessorCode);
                const typeInfo = _metadataInfo.valueType.typeInfo;
                if (typeInfo && typeInfo.metaType.isDto) {
                    setDTOProperties(_viewModelNode, _metadataInfo, ancestorChain);
                }
                return _viewModelNode;
            }


            setDTOProperties(viewModelNode);
            return viewModelNode;
        }


        return {
            /**
             * Create a new view model object based on an object containing data and a metadata type
             *
             * @param modelRoot {Object}: initial data object for view model. Error thrown if data is not an object
             * @param metadataInfo {Object}: metadata information associated with the root model object
             *
             * @return {Object}: A new view model object
             **/
            create: (modelRoot, metadataInfo)=> {
                return createRootViewModelNode(modelRoot, metadataInfo);
            }
        };
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/viewmodel/_VMFactory.js